import { AccordionPanelComponent } from '../accordion-panel/accordion-panel.component';
import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  standalone: true,
  imports: [NgIf],
  selector: 'xilo-accordion-content',
  templateUrl: './accordion-content.component.html',
})
export class AccordionContentComponent {
  @Input() paddingClass = 'px-4 py-2';
  constructor(readonly accordionPanel: AccordionPanelComponent) {}
}
